import { render, staticRenderFns } from "./account-recovery.vue?vue&type=template&id=4d8238d8&"
import script from "./account-recovery.vue?vue&type=script&lang=js&"
export * from "./account-recovery.vue?vue&type=script&lang=js&"
import style0 from "./account-recovery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "account-recovery.vue"
export default component.exports